import * as React from 'react';
import { compose, pure } from 'recompose';
import cn from 'classnames';
import { createStyles, withStyles } from '@material-ui/styles';
import { toCssValue } from '@topconagriculture/theme';
const styles = (theme) => createStyles({
    mainContainer: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        padding: theme.space.padding.default,
        width: '100%',
        maxWidth: theme.layout.width.full,
    },
    viewPortHeight: {
        overflow: 'hidden',
    },
    fullScroll: {
        height: '100%',
    },
    leftSidebar: {
        width: theme.layout.sidebar.full,
    },
    rightSidebar: {
        width: theme.layout.sidebar.full,
    },
    withSidebarLeft: {
        gridTemplateColumns: `auto 1fr`,
        '& $content': {
            marginLeft: theme.space.margin.default,
            paddingRight: theme.space.padding.smallest,
        },
    },
    withSidebarRight: {
        gridTemplateColumns: `1fr auto`,
        '& $content': {
            marginRight: theme.space.margin.default,
        },
    },
    withBothSidebar: {
        gridTemplateColumns: `auto 1fr auto`,
        '& $content': {
            margin: toCssValue([0, theme.space.margin.default]),
        },
    },
    content: {
        overflowY: 'auto',
        overflowX: 'hidden',
    },
});
const PageLayout = (props) => {
    const { classes, leftSidebar, rightSidebar, children, fullScroll = false, className: classNameProp, theme, headerMode, testId = 'Page', } = props;
    const topBarHeight = theme.layout.header.topBar;
    const menuHeight = theme.layout.header.menu;
    const submenuHeight = theme.layout.header.menu;
    const heightMap = {
        withSubmenu: topBarHeight + menuHeight + submenuHeight,
        noMenu: topBarHeight,
        noHeader: 0,
        default: topBarHeight + menuHeight,
    };
    const headerSectionHeight = headerMode ? heightMap[headerMode] : heightMap.default;
    const restSpaceForMainContainer = headerSectionHeight;
    const restSpaceForSidebar = headerSectionHeight + theme.space.padding.default * 2;
    const mainContainerClasses = cn({
        [classes.mainContainer]: true,
        [classes.withSidebarLeft]: !!leftSidebar,
        [classes.withSidebarRight]: !!rightSidebar,
        [classes.withBothSidebar]: !!rightSidebar && !!leftSidebar,
    }, classNameProp);
    const leftSidebarEl = leftSidebar && (React.createElement("aside", { className: classes.leftSidebar, style: { height: `calc(100vh - ${restSpaceForSidebar}px)`, paddingBottom: 5 } }, leftSidebar));
    const rightSidebarEl = rightSidebar && (React.createElement("aside", { className: classes.rightSidebar, style: { height: `calc(100vh - ${restSpaceForSidebar}px)`, paddingBottom: 5 } }, rightSidebar));
    const contentStyle = {
        marginTop: headerSectionHeight,
        height: fullScroll ? '100%' : `calc(100vh - ${restSpaceForMainContainer}px)`,
    };
    return (React.createElement("main", { className: mainContainerClasses, style: contentStyle, "data-testid": testId },
        leftSidebarEl,
        React.createElement("div", { className: classes.content }, children),
        rightSidebarEl));
};
const ComposedPageLayout = compose(withStyles(styles, { withTheme: true }), pure)(PageLayout);
ComposedPageLayout.displayName = 'PageLayout';
export default ComposedPageLayout;
//# sourceMappingURL=PageLayout.js.map